var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3C12.914 3 13.25 3.336 13.25 3.75V6.9L17.1598 4.1625C17.3293 4.044 17.5633 4.08525 17.6825 4.2555C17.726 4.3185 17.75 4.3935 17.75 4.47V13.53C17.75 13.737 17.582 13.905 17.375 13.905C17.2978 13.905 17.2228 13.881 17.1598 13.8375L13.25 11.1V14.25C13.25 14.664 12.914 15 12.5 15H2C1.586 15 1.25 14.664 1.25 14.25V3.75C1.25 3.336 1.586 3 2 3H12.5ZM11.75 4.5H2.75V13.5H11.75V4.5ZM6.5 6H8V8.25H10.25V9.75H7.99925L8 12H6.5L6.49925 9.75H4.25V8.25H6.5V6ZM16.25 6.63075L13.25 8.73075V9.26925L16.25 11.3692V6.63V6.63075Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraPlus);
export default __webpack_public_path__ + "static/media/camera-plus.32d299a3.svg";
export { ForwardRef as ReactComponent };